import { render, staticRenderFns } from "./Apports.vue?vue&type=template&id=66624123&scoped=true"
import script from "./Apports.vue?vue&type=script&lang=js"
export * from "./Apports.vue?vue&type=script&lang=js"
import style0 from "./Apports.vue?vue&type=style&index=0&id=66624123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66624123",
  null
  
)

export default component.exports